export const links = {
  dataPolicyMedical:
    "https://www.instant-help.de/hardware-einwilligung-med-daten/",
  legalDeviceUsage: "https://www.instant-help.de/legal-device-usage/",
  dataPolicy: "https://www.instant-help.de/webseite-datenschutz",
  termsOfUse: "https://www.instant-help.de/app-agb/",
  faq: "https://www.instant-help.de/app-faq",
};

const dev_firebase_config = {
  apiKey: "AIzaSyD99wjqFVU1bkrwjqJNjHJq3w_MiL204wQ",
  authDomain: "dev-b2b-instanthelp.firebaseapp.com",
  projectId: "dev-b2b-instanthelp",
  storageBucket: "dev-b2b-instanthelp.appspot.com",
  messagingSenderId: "1008300301999",
  appId: "1:1008300301999:web:8a152507ab25f1d4573e5a",
};

const production_firebase_config = {
  apiKey: "AIzaSyDE0qpPa58x7X6ouT6eI4gdkBnE2kHfJHo",
  authDomain: "b2b-instanthelp.firebaseapp.com",
  projectId: "b2b-instanthelp",
  storageBucket: "b2b-instanthelp.appspot.com",
  messagingSenderId: "698839192886",
  appId: "1:698839192886:web:581120ce8f6d4753cd0f97",
};

const dev_local = {
  firebase_config: dev_firebase_config,
  region: "europe-west1",
};

const dev = {
  firebase_config: dev_firebase_config,
  region: "europe-west3",
};
const production = {
  firebase_config: production_firebase_config,
  region: "europe-west3",
};

const config =
  process.env.REACT_APP_STAGE === "production"
    ? production
    : process.env.REACT_APP_STAGE === "dev"
    ? dev
    : dev_local;

export default {
  ...config,
  support_mail: "mail@instant-help.de",
};
